<script lang="ts">
	import { browser } from '$app/environment'
	import { goto } from '$app/navigation'
	import { page } from '$app/stores'
	import { PUBLIC_SUPABASE_URL } from '$env/static/public'
	import { Button } from '$lib/shadcn/ui/button'
	import * as Command from '$lib/shadcn/ui/command'
	import * as Popover from '$lib/shadcn/ui/popover'
	import { sortCategories } from '$lib/utils'
	import { Layers, X } from 'lucide-svelte'
	import ProBadge from './ProBadge.svelte'

	export let data
	export let disabled = false

	const nodesArray = Object.values(data.nodes).flat()

	let open = false

	$: value = !disabled ? $page.url.searchParams.get('node') ?? '' : ''
	$: selected = nodesArray.find((s) => s.value === value) ?? null
	$: if (browser && value && window.plausible) {
		window.plausible('Filter by Layer', { props: { layer: value } })
	}
</script>

<Popover.Root bind:open>
	<Popover.Trigger asChild let:builder>
		<Button
			builders={[builder]}
			variant="outline"
			class="lg:h-10 lg:rounded-md {selected ? 'pl-6 pr-9' : 'lg:px-6'}"
			{disabled}
		>
			{#if selected}
				<img
					src="{PUBLIC_SUPABASE_URL}/storage/v1/object/public/assets/nodes/{selected.value}.svg"
					class="h-[18px] w-[18px] -ml-1 mr-2"
					loading="lazy"
					alt=""
				/>
				{selected.label}
				{#if selected.pro}
					<ProBadge />
				{/if}
			{:else}
				<Layers class="mr-2 w-4 h-4" />
				Filter by Layer
			{/if}
		</Button>
		{#if selected}
			<Button
				class="my-auto -ml-[52px]"
				variant="ghost"
				size="icon"
				on:click={() => {
					value = ''
					goto('/scenes')
				}}
			>
				<X class="w-[14px] h-[14px]" />
			</Button>
		{/if}
	</Popover.Trigger>
	<Popover.Content class="z-0 p-0 w-fit" side="right" align="start">
		<Command.Root>
			<Command.Input placeholder="Layer Name…" />
			<Command.List>
				<Command.Empty>No results found.</Command.Empty>
				<Command.Group>
					{#each Object.entries(data.nodes)
						.slice()
						.sort(sortCategories) as [category, nodes]}
						{#each nodes as node}
							<Command.Item
								value={node.value}
								onSelect={(currentValue) => {
									value = currentValue
									open = false
									goto(`/scenes?node=${node.value}`)
								}}
							>
								<img
									src="{PUBLIC_SUPABASE_URL}/storage/v1/object/public/assets/nodes/{node.value}.svg"
									class="h-[18px] w-[18px] mr-2"
									loading="lazy"
									alt=""
								/>
								<span class="whitespace-nowrap">
									{node.label}
								</span>
								{#if node.pro}
									<ProBadge />
								{/if}
							</Command.Item>
						{/each}
					{/each}
				</Command.Group>
			</Command.List>
		</Command.Root>
	</Popover.Content>
</Popover.Root>
